<template>
  <b-modal id="addPriorityService">
    <template slot="modal-header" slot-scope="{ close }">
      <div class="container-fluid">
        <div class="row">
          <div class="col-9 my-auto">
            <h5 class="modal-title">Add Priority Service</h5>
          </div>
          <div class="col-3 my-auto">
            <div>
              <div>
                <span>
                  <a class="close">
                    <i
                      class="far fa-times-circle fa-2x"
                      @click="close()"
                      id="closeAddPriorityService"
                      aria-label="Close"
                    ></i>
                  </a>
                </span>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template slot="default">
      <div class="row text-left">
        <div class="col-12">
          <div class="row">
            <div class="col-sm-3">
              <p class="d-inline-block font-weight-bold pt-1">
                Category:
                <span v-if="!$v.category.required">*</span>
              </p>
            </div>
            <div class="col-sm-9">
              <b-form-select
                v-model="category"
                :class="{ 'is-invalid': submitted && $v.category.$error }"
                @change="details = null"
              >
                <!-- <option :value="null"></option> -->
                <option
                  v-for="(PSR, index) in psrTypes"
                  :key="index"
                  :value="PSR"
                >{{wordSplit(PSR)}}</option>
                <!-- <option value="AdditionalPresencePreferred">Additional Presence Preferred</option>
                <option value="Blind">Blind</option>
                <option value="CarelineTelecareSystem">Careline Telecare System</option>
                <option value="ChronicSeriousIllness">Chronic Serious Illness</option>
                <option value="Dementia">Dementia</option>
                <option value="DevelopmentalCondition">Developmental Condition</option>
                <option value="DialysisFeedingPumpAndAutomatedMedication">
                  Dialysis Feeding Pump And
                  Automated Medication
                </option>
                <option value="FamiliesWithYoungChildren5OrUnder">
                  Families With Young Children 5 Or
                  Under
                </option>
                <option value="HearingSpeechDifficulties">Hearing Speech Difficulties</option>
                <option value="HeartLungAndVentilator">Heart Lung And Ventilator</option>
                <option value="MdeElectricityShowering">Mde Electricity Showering</option>
                <option value="MedicineRefrigeration">Medicine Refrigeration</option>
                <option value="MentalHealth">Mental Health</option>
                <option value="NebuliserAndApnoeaMonitor">Nebuliser And Apnoea Monitor</option>
                <option value="OxygenConcentrator">Oxygen Concentrator</option>
                <option value="OxygenUse">Oxygen Use</option>
                <option value="PartiallySighted">Partially Sighted</option>
                <option value="PensionableAge">Pensionable Age</option>
                <option value="PhysicalImpairment">Physical Impairment</option>
                <option value="PoorSenseOfSmell">Poor Sense Of Smell</option>
                <option value="RestrictedHandMovement">Restricted Hand Movement</option>
                <option value="StairliftHoistElectricBed">Stairlift Hoist Electric Bed</option>
                <option value="TemporaryLifeChanges">Temporary Life Changes</option>
                <option value="TemporaryPostHospitalRecovery">Temporary Post Hospital Recovery</option>
                <option value="TemporaryYoungAdultHouseholder">Temporary Young Adult Householder</option>
                <option value="UnableToAnswerDoorRestrictedMovement">
                  Unable To Answer Door
                  Restricted Movement
                </option>
                <option value="UnableToCommunicateInEnglish">Unable To Communicate In English</option>-->
              </b-form-select>
              <div
                v-if="submitted && !$v.category.required"
                class="invalid-feedback"
              >Please select a priority service.</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <p
                v-if="category != 'UnableToCommunicateInEnglish'"
                class="d-inline-block font-weight-bold pt-1"
              >Details:</p>
              <p v-else class="d-inline-block font-weight-bold pt-1">
                Language:
                <span v-if="!$v.details.required">*</span>
              </p>
            </div>
            <div class="col-sm-9">
              <b-form-select
                v-if="category == 'UnableToCommunicateInEnglish'"
                v-model="details"
                :options="languages"
                @change="specifyLanguage = null"
                :class="{ 'is-invalid': submitted && $v.details.$error }"
              ></b-form-select>
              <textarea
                v-else
                v-model="details"
                type="text"
                class="w-100 border border-secondaryL brs text-left pl-2 pb-1 pt-1"
                pattern="^[A-Za-z -]+$"
              />
              <div
                v-if="submitted && !$v.details.required"
                class="invalid-feedback"
              >Please select a language.</div>
            </div>
          </div>
          <div class="row" v-if="details == 'Other'">
            <div class="col-3">
              <p class="d-inline-block font-weight-bold pt-1">
                Specify:
                <span v-if="!$v.specifyLanguage.required">*</span>
              </p>
            </div>
            <div class="col-9">
              <b-form-input
                v-model="specifyLanguage"
                type="text"
                :class="{ 'is-invalid': submitted && $v.specifyLanguage.$error }"
                pattern="^[A-Za-z -]+$"
              />
              <div
                v-if="submitted && !$v.specifyLanguage.required"
                class="invalid-feedback d-block"
              >Please specify a language.</div>
            </div>
          </div>
          <div
            class="row"
            v-if="this.category == 'FamiliesWithYoungChildren5OrUnder' || 
                    this.category == 'TemporaryLifeChanges' || 
                    this.category == 'TemporaryPostHospitalRecovery' || 
                    this.category == 'TemporaryYoungAdultHouseholder'"
          >
            <div class="col-3">
              <p class="d-inline-block font-weight-bold pt-1">
                To:
                <span v-if="!$v.effectiveTo.required">*</span>
              </p>
            </div>
            <div class="col-9">
              <el-form>
                <el-form-item
                  prop="effectiveTo"
                  :class="{'is-error' : submitted && !$v.effectiveTo.required}"
                >
                  <el-date-picker v-model="effectiveTo" format="dd.MM.yyyy" type="date" />
                  <div
                    v-if="submitted && !$v.effectiveTo.required"
                    class="el-form-item__error"
                  >Please provide an effective to date.</div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template slot="modal-footer">
      <button type="submit" class="btn btn-hc float-right" @click="addPriorityService">Confirm</button>
    </template>
  </b-modal>
</template>

<script>
import moment from "moment";
import Vue from "vue";
import Swal from "sweetalert2";
import { _ } from "underscore";

import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      priorityServices: [],
      effectiveTo: null,
      category: null,
      details: null,
      specifyLanguage: null,
      submitted: false,
      languages: [
        { value: null, text: "" },
        { text: "Arabic" },
        { text: "Bengali" },
        { text: "Chatgaya" },
        { text: "French" },
        { text: "Gujarati" },
        { text: "Panjabi" },
        { text: "Polish" },
        { text: "Portuguese" },
        { text: "Scottish Gaelic" },
        { text: "Spanish" },
        { text: "Sylheti" },
        { text: "Urdu" },
        { text: "Welsh" },
        { text: "Algerian Spoken Arabic" },
        { text: "Amharic" },
        { text: "Arabic" },
        { text: "Assamese" },
        { text: "Azerbaijani" },
        { text: "Baluchi" },
        { text: "Bengali" },
        { text: "Bhojpuri" },
        { text: "Burmese" },
        { text: "Cebuano" },
        { text: "Chatgaya" },
        { text: "Chhattisgarhi" },
        { text: "Chinese" },
        { text: "Chittagonian" },
        { text: "Czech" },
        { text: "Deccan" },
        { text: "Dutch" },
        { text: "Eastern Punjabi" },
        { text: "Egyptian Spoken Arabic" },
        { text: "French" },
        { text: "Fulah" },
        { text: "Gan" },
        { text: "German" },
        { text: "Greek" },
        { text: "Gujarati" },
        { text: "Hakka" },
        { text: "Hausa" },
        { text: "Hijazi Spoken Arabic" },
        { text: "Hindi" },
        { text: "Hungarian" },
        { text: "Igbo" },
        { text: "Indonesian" },
        { text: "Iranian Persian" },
        { text: "Italian" },
        { text: "Japanese" },
        { text: "Javanese" },
        { text: "Jinyu" },
        { text: "Kannada" },
        { text: "Kazakh" },
        { text: "Khmer" },
        { text: "Kinyarwanda" },
        { text: "Korean" },
        { text: "Kurdish" },
        { text: "Lahnda" },
        { text: "Magahi" },
        { text: "Maithili" },
        { text: "Malagasy" },
        { text: "Malay" },
        { text: "Malayalam" },
        { text: "Mandarin" },
        { text: "Marathi" },
        { text: "Marwari" },
        { text: "Mesopotamian Spoken Arabic" },
        { text: "Min Bei Chinese" },
        { text: "Min Dong Chinese" },
        { text: "Min Nan" },
        { text: "Moroccan Spoken Arabic" },
        { text: "Nepali" },
        { text: "Nigerian Fulfulde" },
        { text: "North Levantine Spoken Arabic" },
        { text: "Northern Kurdish" },
        { text: "Northern Pashto" },
        { text: "Northern Uzbek" },
        { text: "Odia" },
        { text: "Oriya" },
        { text: "Oromo" },
        { text: "Panjabi" },
        { text: "Persian" },
        { text: "Polish" },
        { text: "Portuguese" },
        { text: "Pushto" },
        { text: "Romanian" },
        { text: "Rundi" },
        { text: "Russian" },
        { text: "Sa'idi Spoken Arabic" },
        { text: "Sanaani Spoken Arabic" },
        { text: "Saraiki" },
        { text: "Scottish Gaelic" },
        { text: "Serbo-Croatian" },
        { text: "Sindhi" },
        { text: "Sinhala" },
        { text: "Somali" },
        { text: "South Azerbaijani" },
        { text: "South Levantine Spoken Arabic" },
        { text: "Southern Pashto" },
        { text: "Spanish" },
        { text: "Sudanese Spoken Arabic" },
        { text: "Sunda" },
        { text: "Sylheti" },
        { text: "Ta'izzi-Adeni Spoken Arabic" },
        { text: "Tagalog" },
        { text: "Tamil" },
        { text: "Telugu" },
        { text: "Thai" },
        { text: "Tunisian Spoken Arabic" },
        { text: "Turkish" },
        { text: "Ukrainian" },
        { text: "Urdu" },
        { text: "Uyghur" },
        { text: "Uzbek" },
        { text: "Vietnamese" },
        { text: "Welsh" },
        { text: "Western Punjabi" },
        { text: "Wu" },
        { text: "Xiang Chinese" },
        { text: "Yoruba" },
        { text: "Yue" },
        { text: "Zhuang" },
        { text: "Zulu" },
        { text: "Other" }
      ]
    };
  },
  validations() {
    return {
      category: {
        required
      },
      details:
        this.category == "UnableToCommunicateInEnglish"
          ? {
              required
            }
          : "",
      effectiveTo:
        this.category == "FamiliesWithYoungChildren5OrUnder" ||
        this.category == "TemporaryLifeChanges" ||
        this.category == "TemporaryPostHospitalRecovery" ||
        this.category == "TemporaryYoungAdultHouseholder"
          ? {
              required
            }
          : "",
      specifyLanguage:
        this.details == "Other"
          ? {
              required
            }
          : ""
    };
  },
  computed: {
    customer() {
      return this.$store.state.customers.customer;
    },
    activeContract: {
      get() {
        return this.$store.state.contracts.activeContract;
      },
      set(contract) {
        this.$store.commit("updateActiveContract", contract);
      }
    },
    activePSRSet: {
      get() {
        return this.$store.state.contracts.activePSRSet;
      },
      set(set) {
        this.$store.commit("updateActivePSRSet", set);
      }
    },
    psrTypes() {
      let that = this;
      let PSRs = [
        "NebuliserAndApnoeaMonitor",
        "HeartLungAndVentilator",
        "DialysisFeedingPumpAndAutomatedMedication",
        "OxygenConcentrator",
        "Blind",
        "PartiallySighted",
        "StairliftHoistElectricityBed",
        "PensionableAge",
        "PhysicalImpairment",
        "UnableToCommunicateInEnglish",
        "DevelopmentalCondition",
        "UnableToAnswerDoor",
        "DementiaCognitiveImpairment",
        "ChronicSeriousIllness",
        "MedicallyDependentShoweringBathing",
        "CarelineTelecareSystem",
        "MedicineRefrigeration",
        "OxygenUse",
        "PoorSenseOfSmellAndTaste",
        "RestrictedHandMovement",
        "FamiliesWithYoungChildren5OrUnder",
        "MentalHealth",
        "AdditionalPresencePreferred",
        "TemporaryLifeChanges",
        "TemporaryPostHospitalRecovery",
        "TemporaryYoungAdultHouseholder",
        "HearingImpairmentIncludingDeaf",
        "SpeechImpairment",
        "WaterDependent"
      ];
      if (!that.activePSRSet) return PSRs;
      return _.filter(PSRs, function(psr) {
        return !_.pluck(that.activePSRSet.PriorityServices, "PsrType").includes(
          psr
        );
      }).sort();
    }
  },
  methods: {
    addPriorityService() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.activePSRSet.PriorityServices.push({
          EffectiveToDate: this.effectiveTo
            ? moment.utc(moment(this.effectiveTo).format()).format()
            : undefined,
          PsrSpecificDetails:
            this.details != ""
              ? this.category == "UnableToCommunicateInEnglish"
                ? this.details == "Other"
                  ? this.specifyLanguage
                  : this.details
                : this.details
              : undefined,
          PsrType: this.category
        });
        this.effectiveTo = null;
        this.category = null;
        this.details = undefined;
        this.specifyLanguage = undefined;
        this.submitted = false;

        this.savePSRSetChanges();
        document.getElementById("closeAddPriorityService").click();
      }
    },
    removePriorityService(index) {
      this.priorityServices.splice(index, 1);
    },
    savePSRSetChanges() {
      this.$http
        .put(
          "https://" +
            Vue.config.honeycomb.contractbot.domain +
            "/api/v1/PriorityServices/" +
            this.activePSRSet.Id,
          this.activePSRSet,
          {
            withCredentials: true
          }
        )
        .then(response => {
          Swal({
            toast: true,
            position: "top-end",
            type: "success",
            title: "Success! Changes saved.",
            showConfirmButton: false,
            timer: 2500
          });
          this.activePSRSet = response.data;
          this.$store.dispatch("getContracts");
        })
        .catch(error => {
          if (error.response) {
            Swal({
              toast: true,
              position: "top-end",
              type: "error",
              title: error.response.data.UserDescription + " Error",
              showConfirmButton: false,
              timer: 2500
            });
          } else if (error.request) {
            Swal({
              toast: true,
              position: "top-end",
              type: "error",
              title: "No response received",
              showConfirmButton: false,
              timer: 2500
            });
          } else {
            Swal({
              toast: true,
              position: "top-end",
              type: "error",
              title: error,
              showConfirmButton: false,
              timer: 2500
            });
          }
        });
    }
  }
};
</script>